import styled from "styled-components";

export const ActivitySectionAdder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

